// extracted by mini-css-extract-plugin
module.exports = {"downloadBanner":"style_downloadBanner__JK4_2","pattern":"style_pattern__nojrZ","ctIcon":"style_ctIcon__Kr27h"};